import React from 'react';
import { Row } from 'antd';
import { DateTime } from 'luxon';

import TitleRow from './TitleRow';
import FieldTriggerFlag from './FieldTriggerFlag';
import DateTimeSelectionCheckbox from './DateTimeSelectionCheckbox';
import titleOnlyConfigure from './titleOnlyConfigure';
import DateTimeFieldPreview from './DateTimeFieldPreview';

const configure = ({
  id,
  setConfigProps,
  configProps = {},
  setCanSubmit,
  sections = [],
  isExternalForm,
  templateId,
  divisions,
  projectId,
  name,
  isBoardCards,
  setFieldTriggerEditable,
  disableOptional,
  customers = [],
  projects = [],
  users = [],
  costcodes = [],
  phases = [],
  projectIdMap = {},
  vendors = [],
  equipment = [],
  formTemplates = [],
  contactAddressBooks = {},
  labels = [],
  buckets = [],
  isV3Form = false,
} = {}) => {
  const titleOnlyConfig = titleOnlyConfigure({
    id,
    setConfigProps,
    configProps,
    setCanSubmit,
    sections,
    isExternalForm,
    templateId,
    divisions,
    projectId,
    name,
    isBoardCards,
    setFieldTriggerEditable,
    disableOptional,
    customers,
    projects,
    users,
    costcodes,
    phases,
    projectIdMap,
    vendors,
    equipment,
    formTemplates,
    contactAddressBooks,
    labels,
    buckets,
    isV3Form,
  });

  const setHideDate = (checked) => {
    const {
      hideTime,
    } = configProps;

    if (hideTime && checked) {
      setConfigProps({
        ...configProps,
        hideTime: false,
        hideDate: checked,
      });
    } else {
      setConfigProps({
        ...configProps,
        hideDate: checked,
      });
    }
  };

  const setHideTime = (checked) => {
    const {
      hideDate,
    } = configProps;

    if (hideDate && checked) {
      setConfigProps({
        ...configProps,
        hideDate: false,
        hideTime: checked,
      });
    } else {
      setConfigProps({
        ...configProps,
        hideTime: checked,
      });
    }
  };

  const setUse24HourTime = (checked) => {
    setConfigProps({
      ...configProps,
      use24HourTime: checked,
    });
  };

  const setMinuteIncrement = (value) => {
    setConfigProps({
      ...configProps,
      minuteIncrement: value,
    });
  };

  const setDefaultTime = (value) => {
    if (!value) {
      setConfigProps({
        ...configProps,
        defaultTime: null,
      });
      return;
    }
    const millis = value.valueOf();
    const dt = DateTime.fromMillis(millis);
    setConfigProps({
      ...configProps,
      defaultTime: {
        hour: dt.hour,
        minute: dt.minute,
      },
    });
  };

  return (
    <div>
      {titleOnlyConfig}
      <DateTimeSelectionCheckbox
        setHideDate={setHideDate}
        setHideTime={setHideTime}
        setUse24HourTime={setUse24HourTime}
        setMinuteIncrement={setMinuteIncrement}
        setDefaultTime={setDefaultTime}
        configProps={configProps}
      />
    </div>
  );
};

const preview = (props = {}) => {
  const {
    configProps = {},
    responding,
    isDisplay,
    sections,
    isExternalForm,
    templateId,
    projectId,
    divisions,
    onFieldTrigger,
    isFormBuilder,
  } = props;

  const isFieldDisplay = !isFormBuilder && isDisplay;

  const {
    optional,
    title = 'Title goes here',
    fieldTrigger,
  } = configProps;

  return (
    <div style={{ minWidth: 200 }}>
      <TitleRow
        title={title}
        optional={optional}
        isFieldDisplay={isFieldDisplay}
        filter={
          fieldTrigger && !isDisplay
            ? (
              <FieldTriggerFlag
                sections={sections}
                isExternalForm={isExternalForm}
                templateId={templateId}
                projectId={projectId}
                divisions={divisions}
                configProps={configProps}
                responding={responding}
                onFieldTrigger={onFieldTrigger}
              />
            ) : null
        }
      />
      <Row
        style={{
          margin: '10px 0px',
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          gap: '24px',
          pointerEvents: isDisplay ? 'none' : 'auto',
        }}
        gutter={0}
      >
        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
        <DateTimeFieldPreview {...props} />
      </Row>
    </div>
  );
};

export default {
  configure,
  preview,
  title: 'Date/Time',
  description: 'This field allows users to pick a single date/time',
};
